import { toast } from "sonner";

export async function updateYouTubeMetadata({
  userId,
  videoId,
  title,
  description,
  scheduledTime,
  publishNow,
}: {
  userId: string;
  videoId: string;
  title: string;
  description: string;
  scheduledTime: string | null;
  publishNow: boolean;
}): Promise<boolean> {
  try {
    const res = await fetch("http://localhost:5002/youtube-update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        videoId,
        updates: {
          title,
          description,
          scheduledTime,
          publishNow,
        },
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      console.error("❌ YouTube update failed:", data.error);
      toast.error(`YouTube update failed: ${data.error}`);
      return false;
    }

    return true;
  } catch (err) {
    console.error("❌ Error updating YouTube metadata:", err);
    toast.error("Failed to update video on YouTube.");
    return false;
  }
}
